<template>
  <Tooltip :label="$t('shared.button.create_project')">
    <span
      v-if="
        account.attributes && account.attributes.boolean_flags !== undefined
      "
      class="navbar__item__link navbar__item__link--btn"
      @click="showModal"
    >
      <i class="navbar__item__link--icon fas fa-plus" />
    </span>
  </Tooltip>
</template>
<script setup>
import Tooltip from '@/components/shared/tooltip/Tooltip'
import i18n from '@/i18n'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t

const account = computed(() => store.state.account.account)
const toggleProjectModal = () => store.commit('modals/toggleProjectModal')

async function showModal() {
  toggleProjectModal()
}
</script>

<style lang="scss" scoped>
.navbar__item {
  display: flex;
  justify-content: center;
  padding: 0 5px;
  span {
    color: var(--main-grey) !important;
  }
}
.navbar__item__link {
  width: 100%;
  &--btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background: white !important;
    border-radius: var(--border-radius);
    padding: 1.25rem;
    width: 0.625rem;
    height: 0.625rem;
    border: 1px solid #e6e7ec;
    box-shadow: 0px 0px 4px #15174a1a;
    .navbar__item__link--icon {
      color: var(--main-blue-new) !important;
    }
    &:hover {
      background: var(--main-blue-new) !important;
      cursor: pointer;
      .navbar__item__link--icon {
        color: white !important;
      }
    }
  }
}
</style>
